import React, { Component } from 'react';
import Spinner from 'components/Spinner';
import MaterialTable from 'material-table';
import { EYE_ICON, TRASH_ICON, EDIT_ICON, CALENDER_ICON, ContactMailIcon, AddCircleIcon } from 'assets/constants/Icons';
import { INTERVAL, TYPE_SUCCESS, TYPE_FAIL } from 'assets/constants/Constants';
import ShowToast from 'components/ShowToast';
import moment from 'moment';
import { getCustomerList, deleteCustomer } from 'lib/axiosUtils';
import { ThemeProvider } from '@mui/styles';
import { createTheme } from '@mui/material';
import { hasPermission } from 'components/Permission';

export class CustomerListPage extends Component {
    constructor(props) {
        super(props);
        this._isMounted = false;

        this.state = {
            isLoading: true,
            customers: [],
            mytheme: createTheme({}),
            buttonText: 'Create Customer',
            viewOpen: false,
            viewRow: null,
        };
    }

    async componentDidMount() {
        this._isMounted = true;
        console.log('[CustomerListPage] mount -> fetching customers');
        try {
            const resp = await getCustomerList({}, {}); // GET /customers
            const raw = resp?.data?.result ?? resp?.data ?? [];
            const mapped =
                (Array.isArray(raw) ? raw : []).map((c, idx) => ({
                    id: c?._id?.$oid || c?._id || c?.id || `row_${idx}`,
                    customerName: c?.customer_name || '',
                    fullAddress: c?.full_address || '',
                    state: c?.state || '',
                    country: c?.country || '',
                    pinCode: c?.pin_code || '',
                    contactName: c?.contact_name || '',
                    email: c?.email || '',
                    panNo: c?.pan_no || '',
                    gstRegistrationType: c?.gst_registration_type || '',
                    gstNo: c?.gst_no || '',
                    vendorCode: c?.vendor_code || '',
                    defaultCreditPeriodDays:
                        typeof c?.default_credit_period_days === 'number'
                            ? c.default_credit_period_days
                            : '',
                    raw: c,
                })) || [];

            if (this._isMounted) this.setState({ customers: mapped, isLoading: false });
        } catch (err) {
            console.error('[CustomerListPage] fetch customers failed', err);
            if (this._isMounted) this.setState({ isLoading: false });
            ShowToast('Failed to load customers', TYPE_FAIL, INTERVAL, this.props, '');
        }
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    // Navigate to create or edit screen
    goToCreateOrEdit = (rowOrNull) => {
        const payload = rowOrNull
            ? {
                  customerId: rowOrNull.id,
                  prefill: rowOrNull.raw, // pass raw object for edit page prefill
              }
            : null;

        this.props.history.push({
            pathname: '/create-customer-page',
            state: payload,
        });
    };

    // Open view modal
    viewCustomer = (row) => {
        this.setState({ viewOpen: true, viewRow: row });
    };

    // Close view modal
    closeView = () => {
        this.setState({ viewOpen: false, viewRow: null });
    };

    // Delete & refresh
    handleDelete = async (row) => {
        if (!row?.id) {
            ShowToast('Invalid customer id', TYPE_FAIL, INTERVAL, this.props, '');
            return;
        }
        if (!window.confirm('Are you sure you want to delete this customer?')) return;

        if (this._isMounted) this.setState({ isLoading: true });
        try {
            const del = await deleteCustomer({}, {}, row.id);
            const status = del?.status ?? del?.data?.status ?? del?.statusCode;
            const ok = status === 204;
            if (!ok) {
                if (this._isMounted) this.setState({ isLoading: false });
                ShowToast(
                    'Something went wrong. Please try again later.',
                    TYPE_FAIL,
                    INTERVAL,
                    this.props,
                    ''
                );
                return;
            }

            const resp = await getCustomerList({}, {});
            const raw = resp?.data?.result ?? resp?.data ?? [];
            const mapped =
                (Array.isArray(raw) ? raw : []).map((c, idx) => ({
                    id: c?._id?.$oid || c?._id || c?.id || `row_${idx}`,
                    customerName: c?.customer_name || '',
                    fullAddress: c?.full_address || '',
                    state: c?.state || '',
                    country: c?.country || '',
                    pinCode: c?.pin_code || '',
                    contactName: c?.contact_name || '',
                    email: c?.email || '',
                    panNo: c?.pan_no || '',
                    gstRegistrationType: c?.gst_registration_type || '',
                    gstNo: c?.gst_no || '',
                    vendorCode: c?.vendor_code || '',
                    defaultCreditPeriodDays:
                        typeof c?.default_credit_period_days === 'number'
                            ? c.default_credit_period_days
                            : '',
                    raw: c,
                })) || [];

            if (this._isMounted) this.setState({ customers: mapped, isLoading: false });
            ShowToast('Customer deleted successfully', TYPE_SUCCESS, INTERVAL, this.props, '');
        } catch (err) {
            console.error('[CustomerListPage] delete failed', err);
            if (this._isMounted) this.setState({ isLoading: false });
            ShowToast('Delete failed. Please try again.', TYPE_FAIL, INTERVAL, this.props, '');
        }
    };

    renderViewModal() {
        const { viewOpen, viewRow } = this.state;
        if (!viewOpen || !viewRow) return null;

        const r = viewRow;
        return (
            <div className="custom_modal">
                <div className="modal_body">
                    <button
                        type="button"
                        style={{ fontSize: 25 }}
                        className="close text-right"
                        onClick={this.closeView}
                    >
                        &times;
                    </button>
                    <h5 className="mb-3">
                        <b>Customer Details</b>
                    </h5>
                    <hr />
                    <div className="row" style={{
                            background: '#f8f9fa',
                            padding: '10px',
                            borderRadius: '4px',
                            border: '1px solid #dee2e6',
                            margin:'14px'
                        }}>
                        
                        <div className="col-md-6">
                            <p>
                                <b>Customer Name:</b> {r.customerName || '-'}
                            </p>
                            <p>
                                <b>Full Address:</b> {r.fullAddress || '-'}
                            </p>
                            <p>
                                <b>State:</b> {r.state || '-'}
                            </p>
                            <p>
                                <b>Country:</b> {r.country || '-'}
                            </p>
                            <p>
                                <b>PIN Code:</b> {r.pinCode || '-'}
                            </p>
                            <p>
                                <b>Vendor Code:</b> {r.vendorCode || '-'}
                            </p>
                        </div>
                        <div className="col-md-6">
                            <p>
                                <b>Contact Name:</b> {r.contactName || '-'}
                            </p>
                            <p>
                                <b>E-Mail ID:</b> {r.email || '-'}
                            </p>
                            <p>
                                <b>PAN No.:</b> {r.panNo || '-'}
                            </p>
                            <p>
                                <b>GST Registration Type:</b> {r.gstRegistrationType || '-'}
                            </p>
                            <p>
                                <b>GST No.:</b> {r.gstNo || '-'}
                            </p>
                            <p>
                                <b>Default Credit Period (days):</b>{' '}
                                {r.defaultCreditPeriodDays || 0}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        if (this.state.isLoading) return <Spinner />;

        return (
            <div className="main-content">
                <div className="pagetitle row" style={{ color: 'black', paddingTop: 15 , marginTop: '-25px'}}>
                    <div className="col-md-10 sm_device">
                        <ContactMailIcon aria-hidden="true" />
                        <span style={{ marginLeft: '7px', marginRight: '10px' }}>Customer List</span>
                        {hasPermission('customer', 'create') && (
                            <AddCircleIcon  
                                onClick={() => this.goToCreateOrEdit(null)}
                                style={{ 
                                    cursor: 'pointer', 
                                    color: '#1976d2', 
                                    fontSize: '30px !important',
                                }}
                                titleAccess="Add Customer"
                            />
                        )}
                    </div>
                    <div className="col-md-2 sm_device" style={{ textAlign: 'right' }}>
                        <i className={`${CALENDER_ICON}`}></i> {moment().format('DD MMM YYYY')}
                    </div>
                </div>

                <div
                    style={{ borderBottom: '1px solid lightgray', marginBottom: 15, marginTop: 15 }}
                />

                <div className="list-wrapper">
                    {/* <div className="form-button-div">
                        {hasPermission('customer', 'create') && (
                            <button
                                className="brand-button"
                                style={{ width: '190px' }}
                                onClick={() => this.goToCreateOrEdit(null)}
                            >
                                {this.state.buttonText}
                            </button>
                        )}
                    </div> */}

                    <div className="mt-4 border list-table-div bom-table-div" style={{ marginBottom: 50 }}>
                        {this.state.customers.length > 0 ? (
                            <ThemeProvider theme={this.state.mytheme}>
                                <MaterialTable
                                    title=""
                                    columns={[
                                        {
                                            title: 'Customer Name',
                                            field: 'customerName',
                                            sorting: true,
                                            filtering: true,
                                            cellStyle: {
                                                fontSize: 12,
                                                fontWeight: 'bolder',
                                            },
                                        },
                                        {
                                            title: 'Address',
                                            field: 'fullAddress',
                                            sorting: false,
                                            filtering: true,
                                            cellStyle: {
                                                fontSize: 12,
                                                textAlign: 'justify',
                                            },
                                        },
                                        {
                                            title: 'State',
                                            field: 'state',
                                            sorting: true,
                                            filtering: true,
                                        },
                                        {
                                            title: 'Country',
                                            field: 'country',
                                            sorting: true,
                                            filtering: true,
                                        },
                                        {
                                            title: 'PIN Code',
                                            field: 'pinCode',
                                            sorting: true,
                                            filtering: true,
                                        },
                                        // {
                                        //     title: 'Contact Name',
                                        //     field: 'contactName',
                                        //     sorting: true,
                                        //     filtering: true,
                                        //     cellStyle: { color: '#000', fontSize: 12 },
                                        // },
                                        {
                                            title: 'E-Mail ID',
                                            field: 'email',
                                            sorting: true,
                                            filtering: true,
                                        },
                                        {
                                            title: 'PAN No.',
                                            field: 'panNo',
                                            sorting: true,
                                            filtering: true,
                                        },
                                        // {
                                        //     title: 'GST Reg. Type',
                                        //     field: 'gstRegistrationType',
                                        //     sorting: true,
                                        //     filtering: true,
                                        //     cellStyle: { color: '#000', fontSize: 12 },
                                        // },
                                        {
                                            title: 'GST No.',
                                            field: 'gstNo',
                                            sorting: true,
                                            filtering: true,
                                        },
                                        // {
                                        //     title: 'Vendor Code',
                                        //     field: 'vendorCode',
                                        //     sorting: true,
                                        //     filtering: true,
                                        //     cellStyle: { color: '#000', fontSize: 12 },
                                        // },
                                        // {
                                        //     title: 'Default Credit Period (days)',
                                        //     field: 'defaultCreditPeriodDays',
                                        //     type: 'numeric',
                                        //     sorting: true,
                                        //     filtering: false,
                                        //     cellStyle: {
                                        //         color: '#000',
                                        //         fontSize: 12,
                                        //         fontWeight: 600,
                                        //     },
                                        // },
                                    ]}
                                    data={this.state.customers}
                                    actions={[
                                        hasPermission('customer', 'read') && {
                                            icon: () => (
                                                <i className={`${EYE_ICON}`} title="View"></i>
                                            ),
                                            onClick: (_e, rowData) => this.viewCustomer(rowData),
                                        },
                                        hasPermission('customer', 'update') && {
                                            icon: () => (
                                                <i className={`${EDIT_ICON}`} title="Edit"></i>
                                            ),
                                            onClick: (_e, rowData) =>
                                                this.goToCreateOrEdit(rowData),
                                        },
                                        hasPermission('customer', 'delete') && {
                                            icon: () => (
                                                <i className={`${TRASH_ICON}`} title="Delete"></i>
                                            ),
                                            onClick: (_e, rowData) => this.handleDelete(rowData),
                                        },
                                    ].filter(Boolean)}
                                    options={{
                                        pageSize: 5,
                                        pageSizeOptions: [10, 20, 50],
                                        actionsColumnIndex: -1,
                                        headerStyle: {
                                            color: '#2d3d42',
                                            fontWeight: 'bolder',
                                            fontSize: 14,
                                        },
                                        filtering: true,
                                        sorting: true,
                                        columnsButton: true,
                                        exportButton: true,
                                        exportFileName: 'customer_list',
                                        cellStyle:{
                                            color : '#2d3d42',
                                            fontSize: 12
                                        }
                                    }}
                                />
                            </ThemeProvider>
                        ) : (
                            <div className="text-center pt-2">
                                <label>Records not found!</label>
                            </div>
                        )}

                        {this.renderViewModal()}
                    </div>
                </div>
            </div>
        );
    }
}

export default CustomerListPage;
